import { 
  SET_BEFORE_TAB,
  SET_AFTER_TAB,
  SET_CURRENT_QUESTION,
  RESET_STATE
} from '../actions/questions';
import __ from '../helpers/translation';

let defaultState = {
  tabBefore: {
    active: true,
    disabled: false,
    complete: false,
    title: __('app.questions.tab_inspection_before')
  },
  tabAfter: {
    active: false,
    disabled: true,
    complete: false,
    title: __('app.questions.tab_inspection_after')
  },
  //'next': false,
  //'previous': false,
  currentQuestion: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_BEFORE_TAB:
      return Object.assign({}, state, { tabBefore: { ...state.tabBefore, ... action.tab }});
    case SET_AFTER_TAB:
      return Object.assign({}, state, { tabAfter: { ...state.tabAfter, ... action.tab }});
    case SET_CURRENT_QUESTION:
      return Object.assign({}, state, { currentQuestion: action.question });
    case RESET_STATE:
      return Object.assign({}, state, defaultState);
    case 'USER_LOGOUT':
      return Object.assign({}, state, defaultState);
    default:
      return state;
  }
};
